import { ColumnsType } from "antd/lib/table/interface";
import { TABLE_COLUMNS } from "../../../constants/translates";
import { Log } from "../../../models/Log";
import parseDate from "../../../helpers/date";

export default [
  {
    title: TABLE_COLUMNS.creator,
    dataIndex: "user",
    key: "user",
    sorter: false,
    render: (text, entity) => entity.user?.nickname || null,
  },
  {
    title: TABLE_COLUMNS.created_at,
    dataIndex: "date",
    key: "date",
    sorter: false,
    render: (test, entity) => parseDate(entity.created_at),
  },
  {
    title: TABLE_COLUMNS.changed_column,
    dataIndex: "changed_column",
    key: "changed_column",
    sorter: false,
  },
] as ColumnsType<Log>;
